import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { cartQuantityWorker, cartRemoveWorker, cartAddWorker } from 'ducks/cart/actions';

const propTypes = {
  cart: PropTypes.object.isRequired,
  cartAdd: PropTypes.func.isRequired,
  cartRemove: PropTypes.func.isRequired,
  cartQuantity: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired
};

class Cart extends React.Component {

  changeQuantity = (item, value) => {
    let val = value;
    if(isNaN(val)) return false;
    if(val < 1) {
      val = 1;
    }
    this.props.cartQuantity(item.id, val);
  }

  increment = (item) => {
    this.props.cartQuantity(item.id, item.$quantity + 1);
  }

  decrement = (item) => {
    if(item.$quantity < 2) return false;
    this.props.cartQuantity(item.id, item.$quantity - 1);
  }

  remove = (item) => this.props.cartRemove(item);

  add = (item) => this.props.cartAdd(item);

  render() {
    return this.props.children({
      cart: this.props.cart,
      increment: this.increment,
      decrement: this.decrement,
      change: this.changeQuantity,
      remove: this.remove,
      add: this.add
    });
  }
}

const mapState = state => ({
  cart: state.cart
});

const mapDispatch = {
  cartQuantity: cartQuantityWorker,
  cartRemove: cartRemoveWorker,
  cartAdd: cartAddWorker,
};

Cart.propTypes = propTypes;
export default connect(mapState, mapDispatch)(Cart);


// WEBPACK FOOTER //
// ./src/partialComponents/CartController.jsx